import ru from 'dayjs/locale/ru';

const ruWithShortMonth = {
  ...ru,
  name: 'ru_with_short_month',
  months: 'Янв_Фев_Мар_Апр_Май_Июн_Июл_Авг_Сен_Окт_Ноя_Дек'.split('_'),
};

export default ruWithShortMonth;
